import AuthLayoutComponent from '../../features/ui/auth-layout/auth-layout';
import { LoginForm } from '@old/features/public/login/login-form';

export const LoginPage = () => {
  return (
    <AuthLayoutComponent>
      <LoginForm />
    </AuthLayoutComponent>
  );
};
